import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../hooks/useLanguage";

type Props = {};

const Footer = (props: Props) => {
  const { isKr } = useLanguage();
  const footerLayout = isKr ? layoutKr : layoutEng;
  return (
    <footer className="nomb:h-[314px] mb:h-[377px] pt-[75px] nomb:pl-[56px]  w-full bg-gray600 text-white text-[13px] mb:flex mb:flex-col mb:items-center">
      <div className="mb-4 w-[180px]">
        <img src="/assets/brand/huconn-white.svg" width={1740} height={362} className="w-full h-auto" alt="HUCONN" />
      </div>
      <div className="flex nomb:gap-x-[26px] mb:gap-y-[17px] mb:flex-col mb:items-center mb:text-center">
        <div>
          {isKr
            ? <>(주)휴컨 | 대표 강대근 | 사업자등록번호 463-88-00285 <br /> <Link to="/policy" className="underline hover:text-mint transition-colors">약관 및 정책</Link></>
            : <>HUCONN Co., Ltd. | CEO Dae-Geun Kang | Business Registration No. 463-88-00285 <br /> <Link to="/policy" className="underline hover:text-mint transition-colors">Terms & Policies</Link></>
          }
        </div>
        <div className="grid gap-y-[7px]">
          {footerLayout.map(({ asset, content }, idx) => {
            return (
              <div key={idx} className="flex gap-x-[5px] items-center">
                <div>
                  <img src={`/assets/footer/${asset}.svg`} alt={asset} />
                </div>
                <div>{content}</div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="mt-9">Copyright HUCONN, All Rights Reserved</div>
    </footer>
  );
};

export default Footer;

const layoutKr = [
  {
    asset: "place",
    content: "대구 동구 동대구로 465(신천동 대구스케일허브) 1001호",
  },
  {
    asset: "tel",
    content: "053-341-2613  |  FAX  053-341-2627",
  },
  {
    asset: "mail",
    content: "huconn@huconn.com",
  },
];
const layoutEng = [
  {
    asset: "place",
    content: "1001, 465 Dongdaegu-ro, Dong-gu, Daegu (Sincheon-dong, Daegu Scale Hub)",
  },
  {
    asset: "tel",
    content: "053-341-2613  |  FAX  053-341-2627",
  },
  {
    asset: "mail",
    content: "huconn@huconn.com",
  },
];
